import React from 'react'
import { formValues } from 'redux-form'
import { PriceInputWithCurrency } from './index'

const LocalTaxInput = ({ withoutTax, ...rest }) => {
  return (
    <PriceInputWithCurrency
      {...rest}
      nullAtDisabled={false}
      disabled={withoutTax}
    />
  )
}

export default formValues<any>('withoutTax')(LocalTaxInput)
